import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Keeps <link rel="canonical"> in sync with the current route on the
 * production origin (https://relynapp.com). No-op if the tag doesn't exist.
 *
 * Optional `path` overrides the auto-detected location.pathname.
 */
export default function useCanonical(path) {
  const location = useLocation();
  useEffect(() => {
    const link = document.querySelector('link[rel="canonical"]');
    if (!link) return;
    const targetPath = path || location.pathname || "/";
    link.setAttribute("href", `https://relynapp.com${targetPath}`);
  }, [location.pathname, path]);
}
